export enum View {
	Register = 'register',
	Login = 'login',
	RestPassword = 'resetPassword',
	SizeRecommendation = 'sizeRecommendation',
	Analysis = 'Analysis',
	AddItem = 'addItem',
}
